import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "right-sidebar",
  tabindex: "1",
  style: {"overflow":"auto","z-index":"1!important"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"80px"} }, null, -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card-body dashboard-card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 pl-2 h-100 pr-15" }
const _hoisted_8 = { class: "m-0 p-0 font-size-13 float-right dash-ac-title" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = {
  class: "m-0 p-0 font-size-16 float-right dash-ac-balance",
  style: {}
}
const _hoisted_11 = { id: "paymaster_balance" }
const _hoisted_12 = {
  key: 0,
  class: "col-12 p-0",
  id: "paymaster_chartBody"
}
const _hoisted_13 = {
  id: "chart",
  style: {"height":"80px"}
}
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "row right-side-total" }
const _hoisted_16 = { class: "col-6 pr-0" }
const _hoisted_17 = {
  class: "font-size-13 font-grey",
  id: "total_balance"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 p-0 text-right" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-size-13 font-grey" }, "Total Portfolio")
], -1)
const _hoisted_19 = { class: "main-content" }
const _hoisted_20 = { class: "section" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 col-md-4 col-sm-12 text-left d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "mr-4",
      src: "https://map.admin.caprock.com.au/inlancer-admin/images/dashboard.svg",
      style: {"height":"18px"}
    }),
    /*#__PURE__*/_createElementVNode("h5", { class: "font-size-16 font-grey" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Dashboard")
    ])
  ])
], -1)
const _hoisted_23 = { class: "col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center align-items-center" }
const _hoisted_24 = {
  class: "nav nav-pills dashboard-nav mb-3",
  id: "pills-tab",
  role: "tablist"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  id: "v-pills-home-tab",
  "data-toggle": "pill",
  href: "#",
  role: "tab",
  "aria-controls": "v-pills-home",
  "aria-selected": "true"
}, "Overview", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link active",
  id: "v-pills-profile-tab",
  "data-toggle": "pill",
  href: "#",
  role: "tab",
  "aria-controls": "v-pills-profile",
  "aria-selected": "false"
}, "Currencies", -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 col-md-4 col-sm-12 text-right" }, null, -1)
const _hoisted_30 = { class: "tab-content w-100" }
const _hoisted_31 = {
  class: "tab-pane fade show active",
  id: "v-pills-profile",
  role: "tabpanel",
  "aria-labelledby": "v-pills-profile-tab"
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = {
  class: "tab-content w-100",
  id: "pills-tabContent"
}
const _hoisted_34 = {
  class: "tab-pane fade show active",
  id: "pills-profile",
  role: "tabpanel",
  "aria-labelledby": "pills-currency-tab"
}
const _hoisted_35 = { class: "row mt-5 mx-4 p-3 bg-white border-radius-10" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-2 mt-5 d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-16" }, "Currency Rates")
], -1)
const _hoisted_37 = { class: "col-md-12" }
const _hoisted_38 = {
  key: 0,
  class: "row pb-5 mx-1"
}
const _hoisted_39 = { class: "p-2 bg-light" }
const _hoisted_40 = { style: {"padding-right":"5px"} }
const _hoisted_41 = { class: "font-grey font-size-12" }
const _hoisted_42 = { class: "pr-5 font-grey font-size-12 float-right py-1" }
const _hoisted_43 = {
  key: 1,
  style: {"width":"auto","max-height":"320px"}
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "font-grey text-center" }, "No Data Found !!", -1)
const _hoisted_45 = [
  _hoisted_44
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("aside", null, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer_accounts, (ac) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"pointer-events":"none"},
                class: "dashboard-card bg-light mb-0",
                key: ac.userac_id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(ac.ac_name), 1),
                      _hoisted_9,
                      _createElementVNode("p", _hoisted_10, [
                        _createElementVNode("b", _hoisted_11, "$" + _toDisplayString(ac.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                      ])
                    ]),
                    (ac.default_currency_balance>0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_apexchart, {
                              type: "area",
                              height: "100",
                              options: ac.chartOptions,
                              series: ac.series
                            }, null, 8, ["options", "series"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, "$" + _toDisplayString(_ctx.total_ac_balance), 1)
              ]),
              _hoisted_18
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("section", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("ul", _hoisted_24, [
              _createElementVNode("li", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
                class: "nav-item nav-start-tab"
              }, _hoisted_26),
              _createElementVNode("li", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/currency'))),
                class: "nav-item nav-end-tab"
              }, _hoisted_28)
            ])
          ]),
          _hoisted_29
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      (_ctx.dashboard.currencies.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboard.currencies, (currency) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "col-md-4 px-1 mb-2",
                                key: currency.currency_id
                              }, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("span", _hoisted_40, _toDisplayString(currency.icon), 1),
                                  _createElementVNode("span", _hoisted_41, _toDisplayString(currency.currency_name), 1),
                                  _createElementVNode("span", _hoisted_42, _toDisplayString(currency.currency_rate.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 6})), 1)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.dashboard.currencies.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}